import { useNavigate, useLocation } from "react-router-dom";
import { adminLogout } from "../../slice/adminUser/adminUser";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const TopHeader = ({ deliveryMode, onModeChange }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const user = localStorage.getItem("username");

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  const handleLogout = () => {
    dispatch(adminLogout());
    localStorage.clear();
    sessionStorage.clear();
    navigate("/admin/login", { replace: true });
  };

  const applySidebarStyles = (isOpen) => {
    const isMobile = window.innerWidth <= 991;

    const sidebar    = document.querySelector(".page-wrapper.compact-wrapper .page-body-wrapper div.sidebar-wrapper");
    const pageBody   = document.querySelector(".page-wrapper.compact-wrapper .page-body-wrapper .page-body");
    const pageHeader = document.querySelector(".page-wrapper.compact-wrapper .page-header");
    const footer     = document.querySelector(".footer");

    const backBtn = document.querySelector(".back-btn .fa");
    if (backBtn) {
      backBtn.style.transform = isOpen ? "rotate(0deg)" : "rotate(180deg)";
    }

    if (isMobile) {
      if (isOpen) {
        if (sidebar) sidebar.style.left = "0px";
      } else {
        if (sidebar) sidebar.style.left = "-290px";
      }
    } else {
      if (isOpen) {
        if (sidebar)    sidebar.style.left         = "0px";
        if (pageBody)   pageBody.style.marginLeft  = "280px";
        if (pageHeader) {
          pageHeader.style.marginLeft = "280px";
          pageHeader.style.width      = "calc(100% - 280px)";
        }
        if (footer) footer.style.marginLeft = "280px";
      } else {
        if (sidebar)    sidebar.style.left         = "-290px";
        if (pageBody)   pageBody.style.marginLeft  = "0px";
        if (pageHeader) {
          pageHeader.style.marginLeft = "0px";
          pageHeader.style.width      = "100%";
        }
        if (footer) footer.style.marginLeft = "0px";
      }
    }
  };

  const handleToggle = () => {
    const isOpen = !sidebarOpen;
    setSidebarOpen(isOpen);
    applySidebarStyles(isOpen);
  };

  useEffect(() => {
    const backBtn       = document.querySelector(".back-btn");
    const handleBackBtn = () => {
      setSidebarOpen(false);
      applySidebarStyles(false);
    };
    if (backBtn) backBtn.addEventListener("click", handleBackBtn);
    return () => {
      if (backBtn) backBtn.removeEventListener("click", handleBackBtn);
    };
  }, []);

  // Close profile dropdown on outside click
  useEffect(() => {
    const closeDropdown = (e) => {
      if (!e.target.closest(".th-profile")) setProfileOpen(false);
    };
    document.addEventListener("click", closeDropdown);
    return () => document.removeEventListener("click", closeDropdown);
  }, []);

  return (
    <div
      style={{
        display:        "flex",
        alignItems:     "center",
        justifyContent: "space-between",
        padding:        "14px 24px",
        background:     "#fff",
        borderBottom:   "1px solid #eef0f4",
      }}
    >
      {/* ── Left: hamburger + dashboard icon/title ── */}
      <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
        <button
          onClick={handleToggle}
          aria-label="Toggle sidebar"
          style={{
            width:          38,
            height:         38,
            borderRadius:   10,
            border:         "1px solid #e5e7eb",
            background:     "#f8f9fb",
            display:        "flex",
            alignItems:     "center",
            justifyContent: "center",
            cursor:         "pointer",
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4b5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <svg width={22} height={22} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
              d="M21.0003 6.6738C21.0003 8.7024 19.3551 10.3476 17.3265 10.3476C15.2979 10.3476 13.6536 8.7024 13.6536 6.6738C13.6536 4.6452 15.2979 3 17.3265 3C19.3551 3 21.0003 4.6452 21.0003 6.6738Z"
              stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd"
              d="M10.3467 6.6738C10.3467 8.7024 8.7024 10.3476 6.6729 10.3476C4.6452 10.3476 3 8.7024 3 6.6738C3 4.6452 4.6452 3 6.6729 3C8.7024 3 10.3467 4.6452 10.3467 6.6738Z"
              stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd"
              d="M21.0003 17.2619C21.0003 19.2905 19.3551 20.9348 17.3265 20.9348C15.2979 20.9348 13.6536 19.2905 13.6536 17.2619C13.6536 15.2333 15.2979 13.5881 17.3265 13.5881C19.3551 13.5881 21.0003 15.2333 21.0003 17.2619Z"
              stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path fillRule="evenodd" clipRule="evenodd"
              d="M10.3467 17.2619C10.3467 19.2905 8.7024 20.9348 6.6729 20.9348C4.6452 20.9348 3 19.2905 3 17.2619C3 15.2333 4.6452 13.5881 6.6729 13.5881C8.7024 13.5881 10.3467 15.2333 10.3467 17.2619Z"
              stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span style={{ fontWeight: 600, fontSize: 16, color: "#130F26" }}>
            Dashboard
          </span>
        </div>
      </div>

      {/* ── Right: search, notification, avatar ── */}
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        {/* Search */}
       

        {/* Notification bell */}
        <div style={{ position: "relative" }}>
        
   
        </div>

        {/* Avatar + dropdown */}
        <div className="th-profile" style={{ position: "relative" }}>
          <div
            onClick={() => setProfileOpen((p) => !p)}
            style={{
              width:          38,
              height:         38,
              borderRadius:   "50%",
              background:     "linear-gradient(135deg, #2b2b2b 0%, #000 100%)",
              display:        "flex",
              alignItems:     "center",
              justifyContent: "center",
              color:          "#fff",
              fontWeight:     "bold",
              fontSize:       14,
              cursor:         "pointer",
            }}
          >
            {user?.charAt(0).toUpperCase() || "A"}
          </div>

          {profileOpen && (
            <ul
              style={{
                position:     "absolute",
                right:        0,
                top:          46,
                background:   "#fff",
                borderRadius: 10,
                boxShadow:    "0 8px 24px rgba(0,0,0,0.12)",
                listStyle:    "none",
                margin:       0,
                padding:      "6px 0",
                minWidth:     140,
                zIndex:       50,
              }}
            >
              <li>
                
              <a    href="#"
                  onClick={handleLogout}
                  style={{
                    display:    "flex",
                    alignItems: "center",
                    gap:        8,
                    padding:    "10px 16px",
                    fontSize:   14,
                    color:      "#374151",
                    textDecoration: "none",
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                  <span>Log Out</span>
                </a>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopHeader;